























import { Component, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { RoomStorage } from '@/class/roomStorage'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    BtnSquare,
    InputText,
    HeadlineBorder
  }
})
export default class RoomCreate extends Vue {
  room = new Room();
  newMemberName = '';
  isProcessing = false;

  async create () {
    if (this.isProcessing) return

    this.isProcessing = true
    const memberId = await this.room.createRoom(this.newMemberName)
    const roomStorage = new RoomStorage(this.room.id)
    roomStorage.saveRoomMemberId(memberId)

    this.$router.push({ name: 'player', params: { roomId: this.room.id, playerId: memberId } })
  }
}
